export default __webpack_public_path__ + "static/media/cancel.fb5e5666.svg";